import React from "react";
import { useTranslation } from "react-i18next";

import {
  QuestionComponentProps,
  QuestionDefinition,
  QuestionOption,
} from "../../Question";
import { CheckboxQuestion } from "../core";

const QUESTION_ID = "ethnicity";
declare module "@/contexts" {
  interface SurveyAnswers {
    ethnicity?: string[];
  }
}

const EthnicityQuestion: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
  surveyAnswers,
}) => {
  const { t } = useTranslation();

  const options: QuestionOption[] = [
    { id: "hispanic", text: t("ethnicity.options.hispanic") },
    { id: "white", text: t("ethnicity.options.white") },
    { id: "asian", text: t("ethnicity.options.asian") },
    { id: "americanIndian", text: t("ethnicity.options.americanIndian") },
    { id: "black", text: t("ethnicity.options.black") },
    { id: "nativeHawaiian", text: t("ethnicity.options.nativeHawaiian") },
    { id: "middleEastern", text: t("ethnicity.options.middleEastern") },
    { id: "other", text: t("ethnicity.options.other") },
    { id: "preferNotToSay", text: t("ethnicity.options.preferNotToSay") },
  ];

  return (
    <CheckboxQuestion
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      options={options}
      questionHelperText={t("ethnicity.questionHelperText")}
      questionId={QUESTION_ID}
      questionText={t("ethnicity.questionText")}
      selectedItems={surveyAnswers[QUESTION_ID] || []}
    />
  );
};

export const Q_ETHNICITY: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: EthnicityQuestion,
};

export const Q_RETRIAGE_ETHNICITY: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["DPP"],
  shouldShowQuestion: () => true,
  component: EthnicityQuestion,
};
